import React, { Component } from 'react';
import { CHROME_CLEAN, SIGNUP_INTENT } from '../constants';
import SonosAuthentication from '../components/sonos/SonosAuthentication';
import PropTypes from 'prop-types';
import chromeComponent from '../hoc/chromeComponent';

class SonosSignup extends Component {
  static propTypes = {
    router: PropTypes.object.isRequired,
  };

  render() {
    const linkCode = this.props.router.location.query.linkCode;
    return (
      <div className="u-page-container">
        <SonosAuthentication intent={SIGNUP_INTENT} linkCode={linkCode} />
      </div>
    );
  }
}

export default chromeComponent({ type: CHROME_CLEAN })(SonosSignup);
